import { Image } from 'app/src/shared/components'
import { JoinButton } from 'app/src/shared/components/JoinButton'
import image from 'app/static/images/priceValueImage.svg'
import { Card } from 'primereact/card'
import { useTranslation } from 'react-i18next'

export function HomeFooterJoinSection() {
  const { t } = useTranslation('landing')

  return (
    <>
      <div className='mx-auto grid'>
        <Card>
          <div className='grid grid-cols-12'>
            <div className='col-span-10'>
              <div className='text-2xl font-bold'>{t('Landing.Join.Title')}</div>
              <div className='my-[25px]'>{t('Landing.Join.Text')}</div>
            </div>
            <div className='col-span-2'>
              <Image alt='Illustrazione del footer di iscrizione' src={image} />
            </div>
          </div>
          <JoinButton className='mx-5 mb-0 mt-5' />
        </Card>
      </div>
    </>
  )
}
